/**
 * @description 侧边栏菜单 事件总线
 * 用于在任意层级可操作侧边菜单的 <虚拟列表实例>
 */
import mitt from 'mitt';

export type SiderListEvents = {
  autoFocusCurrentRequest: string; // 自动聚焦到当前会话session
  autoFocusCurrentSupplier: string; // 自动聚焦到当前供应商
};

const emitter = mitt<SiderListEvents>();
export default emitter;
